// extracted by mini-css-extract-plugin
export default {"table":"User_table__aq9+1"};